(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["account-content"]) return;
  try {
    
    $('.details-trigger').click(function(){
        if ($(this).next('.details').hasClass('show')){
            $(this).next('.details').removeClass('show');
            $(this).text('show details');
            // console.log('remove');
        } else {
            $(this).next('.details').addClass('show');
            $(this).text('hide details');
            // console.log('add');
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-template"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  if ($('.slider-products.standard.splide').length > 0) {
    const sliders = document.querySelectorAll('.slider-products.standard.splide');
    // Create an IntersectionObserver to initialize sliders lazily
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const sliderElement = entry.target;
          observer.unobserve(sliderElement); // Stop observing once initialized
          // Fetch instance-specific data attributes
          const instanceSettings = {
            perPage: 7,
            perMove: 1,
            type: 'loop',
            focus: 0,
            breakpoints: {
              1500: {
                perPage: 6,
              },
              1200: {
                perPage: 5,
              },
              800: {
                fixedWidth: '185px',
              },
              400: {
                fixedWidth: '155px',
              },
            }
          };
          // Merge global defaults with instance-specific settings
          const settings = pluginSettingsMerge({ ...splideDefaults }, instanceSettings);
          // Initialize Splide
          const splide = new Splide(sliderElement, settings);
          // Attach global overflow behavior
          attachOverflowHandling(splide);
          splide.mount();
        }
      });
    });
    // Observe each slider
    sliders.forEach(slider => {
      observer.observe(slider);
    });
  }
  if ($('.width-two.splide').length > 0) {
    const sliders = document.querySelectorAll('.width-two.splide');
    // Create an IntersectionObserver to initialize sliders lazily
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const sliderElement = entry.target;
          observer.unobserve(sliderElement); // Stop observing once initialized
          // Fetch instance-specific data attributes
          const instanceSettings = {
            perPage: 2,
            perMove: 1,
            type: 'loop',
            focus: 0,
            breakpoints: {
              320: {
                perPage: 2,
                fixedWidth: '160px',
              },
            }
          };
          // Merge global defaults with instance-specific settings
          const settings = pluginSettingsMerge({ ...splideDefaults }, instanceSettings);
          // Initialize Splide
          const splide = new Splide(sliderElement, settings);
          // Attach global overflow behavior
          attachOverflowHandling(splide);
          splide.mount();
        }
      });
    });
    // Observe each slider
    sliders.forEach(slider => {
      observer.observe(slider);
    });
  }
});

document.addEventListener('click', function(e) {
  if (e.target.classList.contains('link_remove')) {
    e.preventDefault();
    const key = e.target.dataset.lineItemKey;

    // Remove the main item
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: 0
      })
    })
    .then(res => res.json())
    .then(cart => {
      // Check for embroidery add-ons linked to this key
      const linked = cart.items.filter(item =>
        item.properties &&
        item.properties._note === 'Embroidery Add-on' &&
        item.properties._parent_line_item === key
      );

      return Promise.all(linked.map(item =>
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        })
      ));
    })
    .then(() => window.location.reload()) // Or re-render the cart if you prefer
    .catch(console.error);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcement"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if ($('.announcement.visible.items.splide').length > 0) {
      $('.announcement.visible.items.splide').each(function() {
        // Fetch instance-specific data attributes
        const instanceSettings = {
          type: 'loop',
          autoplay: true,
          interval: 4000,
          autoHeight: false,
          pagination: false,
          focus: 'center',
          pauseOnHover: true,
          pauseOnFocus: true,
          classes: {
            arrows: 'splide__arrows controls',
            arrow: 'splide__arrow control',
            prev: 'slider_arrow sml prev',
            next: 'slider_arrow sml next',
          }
        };
        // Merge global defaults with instance-specific settings
        const settings = pluginSettingsMerge({ ...splideDefaults }, instanceSettings);
        // Initialize Splide for this slider
        new Splide(this, settings).mount();
      });
    }   
  });  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-messages"]) return;
  try {
    
$('.info-popup-holder .control-close, .info-popup-holder .btn_black_reg').click(function(){
    $(this).parents('.info-popup-holder').removeClass('show').addClass('hide');
});

$('.popup-trigger').click(function(){
    // console.log('clicked');
    var popup = $(this).data('popup');
    // console.log(popup);
    if ($('.'+popup+'.info-popup-holder').length > 0){
        if ($('.'+popup+'.info-popup-holder').hasClass('hide')){
            $('.'+popup+'.info-popup-holder').removeClass('hide').addClass('show');

            if ($(this).data('url')) {
                $('.'+popup+'.info-popup-holder .btn_black_reg').attr("href", $(this).data('url'));
            }
            if (popup == 'cancel') {
                $('#ContactFormMessage').focus();
                var orderNumber = $(this).data('ordername');
                var customerEmail = $(this).data('email');
                $('.order-number').text(orderNumber);
                $('#ContactOrderName').val(orderNumber);
                $('#ContactFormEmail').val(customerEmail);
            }
        }
    }
});

//has the form been submitted? If no, flag so we can show the popup
// var cancelNotSubmitted;
// if ($.cookie('cancelordersubmitted') == null) {
//     cancelNotSubmitted = true;
// }
// else {
//     cancelNotSubmitted = false;
// }
 
// $(window).on("load", function() {
//   var cancelSubmitted = $.cookie('cancelordersubmitted');
// //   console.log('submitted:' + cancelSubmitted);
//   if (document.referrer.indexOf("challenge") > -1 && window.location.href.indexOf("account") > -1 || window.location.href.indexOf("?contact_posted=true#cancel-order-popup-form") > -1) {
//     //show popup
//     if ($('.cancel.info-popup-holder').length > 0) {
//       $('.cancel.info-popup-holder').addClass('show');
        
//         $('.info-popup-holder .control-close').click(function(){
//             // $.cookie('cancelordersubmitted', '', { expires: 1, path: '/' });
//             window.location.href = window.location.href.split('?')[0];
//         });
//     }
//   }
// });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  if ($('.product-top .imgs.splide').length > 0) {
    const sliders = document.querySelectorAll('.product-top .imgs.splide');
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const sliderElement = entry.target;
          observer.unobserve(sliderElement); // Stop observing once initialized

          // Slider-specific settings
          const instanceSettings = {
            fixedWidth: '50vh',
            perMove: 1,
            type: 'loop',
            focus: 'center',
            preloadPages: 2,
            updateOnMove: true,
            breakpoints: {
              580: {
                perPage: 1,
                fixedWidth: '360px',
              },
              420: {
                perPage: 1,
                fixedWidth: '280px',
              },
              280: {
                perPage: 1,
                fixedWidth: '100%',
              },
            },
          };

          // Merge global defaults with instance-specific settings
          const settings = pluginSettingsMerge({ ...splideDefaults }, instanceSettings);

          // Initialize Splide
          const splide = new Splide(sliderElement, settings);

          // Attach global overflow behavior
          attachOverflowHandling(splide);

          // Mount the slider and make it globally accessible
          window.productImgSplide = splide.mount();

          // Hide the sibling with the class "placeholder"
          const placeholder = sliderElement.parentElement.querySelector('.placeholder');
          if (placeholder) {
            setTimeout(() => {
              placeholder.style.opacity = '0'; // Set opacity to 0
              // placeholder.classList.add('hidden'); // Optionally add a hidden class
            }, 5000);
          }
        }
      });
    });
    sliders.forEach(slider => observer.observe(slider));
  }
  if ($('.slider-products.with-overlay.splide').length > 0) {
    const sliders = document.querySelectorAll('.with-overlay.splide');
    // Create an IntersectionObserver to initialize sliders lazily
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const sliderElement = entry.target;
          observer.unobserve(sliderElement); // Stop observing once initialized
          // Fetch instance-specific data attributes
          const instanceSettings = {
            perPage: 6,
            perMove: 1,
            type: 'loop',
            focus: 0,
            
            breakpoints: {
              1500: {
                perPage: 5,
              },
              1200: {
                perPage: 4,
              },
              800: {
                perPage: 3,
              },
              600: {
                fixedWidth: '240px',
              },
              320: {
                fixedWidth: '200px',
              },
            }
          };
          // Merge global defaults with instance-specific settings
          const settings = pluginSettingsMerge({ ...splideDefaults }, instanceSettings);
          // Initialize Splide
          const splide = new Splide(sliderElement, settings);
          // Attach global overflow behavior
          attachOverflowHandling(splide);
          splide.mount();
        }
      });
    });
    // Observe each slider
    sliders.forEach(slider => {
      observer.observe(slider);
    });
  }
  if ($('.slider-products.standard.splide').length > 0) {
    const sliders = document.querySelectorAll('.slider-products.standard.splide');
    // Create an IntersectionObserver to initialize sliders lazily
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const sliderElement = entry.target;
          observer.unobserve(sliderElement); // Stop observing once initialized
          // Fetch instance-specific data attributes
          const instanceSettings = {
            perPage: 7,
            perMove: 1,
            type: 'loop',
            focus: 0,
            breakpoints: {
              1500: {
                perPage: 6,
              },
              1200: {
                perPage: 5,
              },
              800: {
                fixedWidth: '185px',
              },
              400: {
                fixedWidth: '155px',
              },
            }
          };
          // Merge global defaults with instance-specific settings
          const settings = pluginSettingsMerge({ ...splideDefaults }, instanceSettings);
          // Initialize Splide
          const splide = new Splide(sliderElement, settings);
          // Attach global overflow behavior
          attachOverflowHandling(splide);
          splide.mount();
        }
      });
    });
    // Observe each slider
    sliders.forEach(slider => {
      observer.observe(slider);
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-home_wow_parallax-single"] && !Shopify.designMode) return;
  try {
    
  // const video = document.querySelector('.single.parallax video');
  // video.addEventListener('play', () => {
  //   video.classList.add('playing');
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-static_gifting-quiz"]) return;
  try {
    
    window.addEventListener('unload', function(event) {
        document.getElementById("gifting-quiz-holder").reset();
    }, false);

    $(document).ready(function(){

        $('#gifting-quiz input').prop('checked', false);
        
        var datacollectionhandle;
        var datacollectioncolours;
        var datacollectionbrief;
        var datacollectionthong;

        var datacollectionbrawireless;
        var datacollectionbrawired;
        var datacollectionbracupless;

        var datacollectiontypes;
        var datashoptypes;

        var datashopbrief = $('.quiz_field-style').data('shop-brief');
        var datashopthong = $('.quiz_field-style').data('shop-thong');

        var datashopbrawireless = $('.quiz_field-style').data('shop-bra-wireless');
        var datashopbrawired = $('.quiz_field-style').data('shop-bra-wired');
        var datashopbracupless = $('.quiz_field-style').data('shop-bra-cupless');

        var filterbottoms = datashopthong + '&' + datashopbrief;
        var filterbra = datashopbrawired + '&' + datashopbrawireless + '&' + datashopbracupless;

        var filtercolour;

        var filteredbottoms;
        var filteredbra;
        var filteredcolour;

        $('.quiz_field-style input').bind('click', function() {
            $(this).parents('.step').siblings().find('input').prop('checked', false);

            datacollectionhandle = $(this).data('collection-handle');

            if ($(this).val() == 'quiz_field-style-4') {
                $('.quiz_field-colour input#quiz_field-colour-black, .quiz_field-colour input#quiz_field-colour-neutral').attr("disabled", true);
            } else {
                $('.quiz_field-colour input#quiz_field-colour-black, .quiz_field-colour input#quiz_field-colour-neutral').attr("disabled", false);
            }

            datacollectioncolours = $(this).data('collection-colours');
            datacollectionbrief = $(this).data('collection-brief');
            datacollectionthong = $(this).data('collection-thong');

            datacollectionbrawireless = $(this).data('collection-bra-wireless');
            datacollectionbrawired = $(this).data('collection-bra-wired');
            datacollectionbracupless = $(this).data('collection-bra-cupless');

            datacollectiontypes = $(this).data('collection-types');

            if (datacollectionbrief) {
                $('.quiz_field-bottoms input[value="briefs"]').attr("disabled", false);
            } else {
                $('.quiz_field-bottoms input[value="briefs"]').attr("disabled", true);                
            }
            if (datacollectionthong) {
                $('.quiz_field-bottoms input[value="thongs"]').attr("disabled", false);
            } else {
                $('.quiz_field-bottoms input[value="thongs"]').attr("disabled", true);                
            }
            if (datacollectionbrawired) {
                $('.quiz_field-bra input[value="wired"]').attr("disabled", false);
            } else {
                $('.quiz_field-bra input[value="wired"]').attr("disabled", true);
            }
            if (datacollectionbrawireless) {
                $('.quiz_field-bra input[value="non-wired"]').attr("disabled", false);
            } else {
                $('.quiz_field-bra input[value="non-wired"]').attr("disabled", true);
            }
            if (datacollectionbracupless) {
                $('.quiz_field-bra input[value="cupless"]').attr("disabled", false);
            } else {
                $('.quiz_field-bra input[value="cupless"]').attr("disabled", true);
            }
        });
        $('.quiz_field-bottoms input').bind('click', function() {
            if ($(this).val() == 'thongs') {
                if (datacollectionthong) {
                    filterbottoms = datacollectionthong;
                } else {
                    filterbottoms = datashopthong;
                }
            } else if ($(this).val() == 'briefs') {
                if (datacollectionbrief) {
                    filterbottoms = datacollectionbrief;
                } else {
                    filterbottoms = datashopbrief;
                }
            } else {
                if (datacollectionthong && datacollectionbrief) {
                    filterbottoms = datacollectionthong + '&' + datacollectionbrief;
                } else {
                    filterbottoms = datashopthong + '&' + datashopbrief;
                }
            }
        });
        $('.quiz_field-bra input').bind('click', function() {
            if ($(this).val() == 'wired') {
                if (datacollectionbrawired) {
                    filterbra = datacollectionbrawired;
                } else {
                    filterbra = datashopbrawired;
                }
            } else if ($(this).val() == 'non-wired') {
                if (datacollectionbrawireless) {
                    filterbra = datacollectionbrawireless;
                } else {
                    filterbra = datashopbrawireless;
                }
            } else if ($(this).val() == 'cupless') {
                if (datacollectionbracupless) {
                    filterbra = datacollectionbracupless;
                } else {
                    filterbra = datashopbracupless;
                }
            } else {
                if (datacollectionbrawired && datacollectionbrawireless && datacollectionbracupless) {
                    filterbra = datacollectionbrawired + '&' + datacollectionbrawireless + '&' + datacollectionbracupless;
                } else {
                    filterbra = datashopbrawired + '&' + datashopbrawireless + '&' + datashopbracupless;
                }
            }
        });
        $('.quiz_field-colour input').bind('click', function() {
            var selected = new Array();
            $("input:checkbox[name=quiz_field-colour]:checked").each(function() {
                selected.push($(this).val());
            });
            filtercolour = selected.join('');
        });

        $('#gifting-quiz input').bind('click', function() {
            datacollectionbrawireless;
            datacollectionbracupless;
            datacollectionbrawired;
            datacollectionthong;
            datacollectionbrief;

            if (datacollectionhandle == null) {
                datacollectionhandle = 'all';
            } else {
                datacollectionhandle;
            }

            if (datacollectiontypes) {
                if (filterbra) {
                    filteredbra = '&' + filterbra;
                } else {
                    filteredbra = '&' + datacollectionbrawired + '&' + datacollectionbrawireless + '&' + datacollectionbracupless;
                }


                if (filterbottoms) {
                    filteredbottoms = '&' + filterbottoms;
                } else {
                    filteredbottoms = '&' + datacollectionthong + '&' + datacollectionbrief;
                }
            } else {
                datacollectiontypes = $('.quiz_field-style').data('shop-types');
                
                if (filterbra) {
                    filteredbra = '&' + filterbra;
                } else {
                    filteredbra = '&' + datashopbrawired + '&' + datashopbrawireless + '&' + datashopbracupless;
                }


                if (filterbottoms) {
                    filteredbottoms = '&' + filterbottoms;
                } else {
                    filteredbottoms = '&' + datashopthong + '&' + datashopbrief;
                }
            }

            filteredbra = '&' + filterbra;
            filteredbottoms = '&' + filterbottoms;

            if (filtercolour) {
                filteredcolour = filtercolour;
            } else {
                filteredcolour = '';
            }
            datacollectiontypesfiltered = datacollectiontypes + filteredbra + filteredbottoms + filteredcolour;

            console.log('/collections/'+datacollectionhandle+'?'+datacollectiontypesfiltered);

            $('.btn.find').attr('href', ('/collections/'+datacollectionhandle+'?'+datacollectiontypesfiltered));
        });
        
});
document.addEventListener('DOMContentLoaded', function () {
  if ($('.slider-products.splide.with-overlay').length > 0) {
    const sliders = document.querySelectorAll('.slider-products.splide.with-overlay');
    // Create an IntersectionObserver to initialize sliders lazily
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const sliderElement = entry.target;
          observer.unobserve(sliderElement); // Stop observing once initialized
          // Fetch instance-specific data attributes
          const instanceSettings = {
            perPage: 1,
            perMove: 1,
            type: 'loop',
            focus: 0
          };
          // Merge global defaults with instance-specific settings
          const settings = pluginSettingsMerge({ ...splideDefaults }, instanceSettings);
          // Initialize Splide
          const splide = new Splide(sliderElement, settings);
          // Attach global overflow behavior
          attachOverflowHandling(splide);
          splide.mount();
        }
      });
    });
    // Observe each slider
    sliders.forEach(slider => {
      observer.observe(slider);
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section_rich-content"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  // Initialize sliders if they exist
  if ($('.slider-content.splide').length > 0) {
    const sliders = document.querySelectorAll('.slider-content.splide');
    // Create an IntersectionObserver to initialize sliders lazily
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const sliderElement = entry.target;
          observer.unobserve(sliderElement); // Stop observing once initialized
          // Fetch instance-specific data attributes
          const instanceSettings = {
            type: 'loop',
            perPage: $(sliderElement).data('mediacount') || 1,
            perMove: 1,
            arrows: false,
            pagination: true,
            autoplay: $(sliderElement).data('mediaauto') || false,
            interval: 3000,
            classes: {
              pagination: 'splide__pagination dots',
              page: 'splide__pagination__page control',
            },
          };
          // Merge global defaults with instance-specific settings
          const settings = pluginSettingsMerge({ ...splideDefaults }, instanceSettings);
          // Initialize Splide for this slider
          new Splide(sliderElement, settings).mount();
        }
      });
    });
    // Observe each slider
    sliders.forEach(slider => {
      observer.observe(slider);
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section_slider-img-txt"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  if ($('.slider-imgtxt.items.splide').length > 0) {
    const sliders = document.querySelectorAll('.slider-imgtxt.items.splide');
    // Create an IntersectionObserver to initialize sliders lazily
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const sliderElement = entry.target;
          observer.unobserve(sliderElement); // Stop observing once initialized
          // Fetch instance-specific data attributes
          const instanceSettings = {
            type: 'loop',
            autoplay: true,
            interval: 6000,
            autoHeight: false,
            focus: 'center',
            pauseOnHover: true,
            pauseOnFocus: true,
            pagination: true,
            arrows: false
          };
          // Merge global defaults with instance-specific settings
          const settings = pluginSettingsMerge({ ...splideDefaults }, instanceSettings);
          // Initialize Splide for this slider
          new Splide(sliderElement, settings).mount();
        }
      });
    });
    // Observe each slider
    sliders.forEach(slider => {
      observer.observe(slider);
    });
  }   
}); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section_slider-imgblocks"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  if ($('.featured_collections.splide').length > 0) {
    const sliders = document.querySelectorAll('.featured_collections.splide');
    // Create an IntersectionObserver to initialize sliders lazily
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const sliderElement = entry.target;
          observer.unobserve(sliderElement); // Stop observing once initialized

          pagingStyle = $(sliderElement).data('paging-style');
          if (pagingStyle == 'paging-bars') {
            pagingPagination = true;
            pagingArrows = false;
          }
          if (pagingStyle == 'paging-arrows') {
            pagingPagination = false;
            pagingArrows = true;
          }
          if (pagingStyle == 'paging-combi') {
            pagingPagination = true;
            pagingArrows = true;
          }
          
          // Fetch instance-specific data attributes
          const instanceSettings = {
            perPage: $(sliderElement).data('per-page'),
            perMove: 1,
            type: 'loop',
            autoplay: false,
            focus: 0,
            pagination: pagingPagination,
            arrows: pagingArrows,
          };
          // Merge global defaults with instance-specific settings
          const settings = pluginSettingsMerge({ ...splideDefaults }, instanceSettings);
          // Initialize Splide for this slider
          new Splide(sliderElement, settings).mount();
        }
      });
    });
    // Observe each slider
    sliders.forEach(slider => {
      observer.observe(slider);
    });
  }   
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section_slider-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  if ($('.slider-products.splide').length > 0) {
    const sliders = document.querySelectorAll('.slider-products.splide');
    // Create an IntersectionObserver to initialize sliders lazily
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const sliderElement = entry.target;
          observer.unobserve(sliderElement); // Stop observing once initialized
          // Fetch instance-specific data attributes
          const instanceSettings = {
            perPage: 6,
            perMove: 1,
            type: 'loop',
            focus: 0,
            
            breakpoints: {
              1500: {
                perPage: 5,
              },
              1200: {
                perPage: 4,
              },
              800: {
                fixedWidth: '240px',
              },
              525: {
                fixedWidth: '200px',
              },
              475: {
                fixedWidth: '185px',
              },
              400: {
                fixedWidth: '155px',
              } 
            }
          };
          // Merge global defaults with instance-specific settings
          const settings = pluginSettingsMerge({ ...splideDefaults }, instanceSettings);
          // Initialize Splide
          const splide = new Splide(sliderElement, settings);
          // Attach global overflow behavior
          attachOverflowHandling(splide);
          splide.mount();
        }
      });
    });
    // Observe each slider
    sliders.forEach(slider => {
      observer.observe(slider);
    });
  }
}); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section_video"] && !Shopify.designMode) return;
  try {
    
  //check to see if HTML5 video is supported
  var supports_video = function(){
  return !!document.createElement('video').canPlayType;
  }
  // detect IE8 and above, and edge
  if (document.documentMode || /Edge/.test(navigator.userAgent)) {
      $('.video-image .play').hide();
      $('.video-image .caption-content').append('<span class="disabled">Video playback is not supported, please use another browser</span>');
  }
  var videoOnClick = {
    init: function () {
      var settings = {
        container: $('.section-video'),
        header: $('.video--media'),
        videoTrigger: $("[data-play-video]"),
      };
      videoOnClick.bindClickAction(settings);
    },
    bindClickAction: function (settings) {
      $('body').on('click', '[data-play-video]', function (e) {
        e.preventDefault();

        var $button = $(this);
        var $section = $button.closest('.section-video');
        var $videoHolder = $section.find('.vid-holder');
        var $video = $videoHolder.find('video');

        // Check if the video already exists
        if (!$video.length) {
          videoOnClick.appendFrame($section, $button);
        } else {
          // Toggle play/pause
          if ($video[0].paused) {
            $video[0].play();
            videoOnClick.updateButton($button, "pause");
          } else {
            $video[0].pause();
            videoOnClick.updateButton($button, "play");
          }
        }
      });
    },
    appendFrame: function ($section, $button) {
      var videoDetails = {
        videoMP4: $section.find('.video--media').data('video-mp4'),
        posterImg: $section.find('.video--media').data('poster'),
        videoPadding: $section.find('.video--media').data('padding'),
      };

      var videoHTML =
        '<div class="vid-holder" style="padding-bottom:' +
        videoDetails.videoPadding +
        '; opacity: 0; transition: opacity 0.5s;"><video class="vid-media" autoplay controls muted poster="' +
        videoDetails.posterImg +
        '"><source src="' +
        videoDetails.videoMP4 +
        '" type="video/mp4"></video></div>';

      // Append video frame
      var $vidHolder = $section.find('.video--media').append(videoHTML).find('.vid-holder');
      // Delay opacity change to ensure smooth load
      setTimeout(function () {
        $vidHolder.css('opacity', 1);
      }, 200); // Add a slight delay for smooth transition
      // Update button to "pause"
      videoOnClick.updateButton($button, "pause");
      // Listen for play/pause events
      var $video = $section.find('.vid-media');
      $video.on('pause', function () {
        videoOnClick.updateButton($button, "play");
      });
      $video.on('play', function () {
        videoOnClick.updateButton($button, "pause");
      });
    },
    updateButton: function ($button, state) {
      if (state === "pause") {
        $button.text("Pause Video").addClass("pause").removeClass("play");
      } else {
        $button.text("Play Video").addClass("play").removeClass("pause");
      }
    },
  };
  // Initialize if the section exists
  if ($('.section-video').length) {
    videoOnClick.init();
  }

  } catch(e) { console.error(e); }
})();
})();
